module.exports = __webpack_public_path__ + "img/f-thermometer-img1-2.a743c570.png";